var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceReceivedBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M38.6 46.7H23.4V32.4c0-4 3.4-7.3 7.6-7.3 4.2 0 7.6 3.3 7.6 7.3v14.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M31.2 24.9h64.9c4.2 0 7.6 3.3 7.6 7.3v22M118.6 105.1v14H24.2v-14M118.6 105.1V64.7l-15-10.5M38.6 54.6L24.2 64.7v40.4M38.6 74.7v-28M103.6 74.9V54.2M53.3 37.1h36.5M71.6 96.7V57.9M53.3 67h36.5M53.3 75.9h36.5M53.3 84.9H89M76.6 93.3H65.5M53.3 46.6h36.5M53.3 84.9v-27h36.5v26.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M118.6 64.7l-15 10.2-13.8 9.4-.8.6-12.4 8.4-5 3.4-.6.4-5.5-3.8-12.2-8.4-14.7-10.2-14.4-10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceReceivedBig);
export default __webpack_public_path__ + "static/media/invoiceReceivedBig.f6cee18f8d9f7eec2dff17f3219a20f0.svg";
export { ForwardRef as ReactComponent };